import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { postTestData } from "../../crud/auth.crud"
import { getSummaryTopData } from "../../crud/dashboard.crud"
import Util from "pages/Dashboard/Common/Util";
import CollectionSettlement from "../Bill/CollectionSettlement_v2"
import CollectionPayment from "../Bill/CollectionPayment_v2"
import TreatmentSettlement from "../Bill/TreatmentSettlement_v2"
import TreatmentPayment from "../Bill/TreatmentPayment_v2"

import loading from "../../assets/images/loading.gif";
import weaverOverlay from "../../assets/images/weaver_overlay.png"
import SelectBox from "components/RopikCustom/SelectBox.js";
import Modal from "components/RopikCustom/Modal";
import Loading from "pages/Custom/Loading";
// import Modal from "components/RopikCustom/Modal_v2";
import * as XLSX from 'xlsx';

const initSearchCondition = {
  companyName: '',
  companyNumber: '',
}

const initInputCondition = {
  id: '',
  companyName: '',
  treatmentCompanyName: '',
  collectZone: '',
  car: '',
  collectDate: moment().hour() < 14 ? moment().clone().subtract(1, 'day').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
  driver: '',
  report: 'N',
  qty: 0,
  price: 0,
  min_price: 0,
  min_l: 0,
  is_vat: 'Y',
  billing_type: '종량제',
  rf_id: '',
  qty_type: 'l',
  state: 'I'
}

const initDashboardItem = [
  { text: '금월 총 인계량(ton)', unit: '', value: 0 },
  { text: '금월 정산금액', unit: '', value: 0 },
  { text: '전월 인계량(ton)', unit: '', value: 0 },
  { text: '금월 정산금액', unit: '', value: 0 },
]

const selectedClass = 'secondary-bg white-text border-none'
const unselectedClass = 'button-border secondary-text white-bg'

const paymentStatusList = [
  { id: 'A', name: '전체' },
  { id: 'N', name: '미납' }
]

const TreatmentSettlementManagement = () => {

  const selector = useSelector(state => state)

  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [modalShow, setModalShow] = useState({
    edit: false,
    deactivate: false
  })
  const [dashboardItem, setDashboardItem] = useState(initDashboardItem)
  const type = selector.auth.user?.type || "";
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(initInputCondition)
  const [listCount, setListCount] = useState(0)
  const [settlementState, setSettlementState] = useState('settlement')
  const [paymentStatus, setPaymentStatus] = useState('A')
  const [searchState, setSearchState] = useState(0)
  const [settlementDate, setSettlementDate] = useState(moment().format('YYYY-MM'))

  const getSummaryData = async () => {
    try {
      const response = await getSummaryTopData();
      if (response.status === 200) {
        const content = response.data?.data || [];
        const item = [
          { text: '금월 총 인계량(ton)', unit: '', value: Util.setCommaPrice(content?.wearing_month_sum / 1000) },
          { text: '금월 정산금액', unit: '', value: Util.setCommaPrice(content?.report_month_sum) },
          { text: '전월 인계량(ton)', unit: '', value: Util.setCommaPrice(content?.wearing_prev_month_sum / 1000) },
          { text: '전월 정산금액', unit: '', value: Util.setCommaPrice(content?.prev_report_month_sum) },
        ]
        setDashboardItem(item)
      }
    } catch (error) {
      console.error(error);
    }
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({ ...prev, [key]: true }))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({ ...prev, [key]: false }))
    setSelectedItem(initInputCondition)
  }


  const excelDownload = async () => {
    const table = document.getElementById('excel-table');
    if (!table) return;

    const rows = table.querySelectorAll('tr');
    const data = [];

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td, th');
      const rowData = [];

      for (let j = 0; j < cells.length; j++) {
        rowData.push(cells[j].innerText);
      }

      data.push(rowData);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob(
      [wbout],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${settlementState === 'settlement' ? '처리장 정산내역' : '처리장 고지내역'}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  const testData = async() => {
    let url = '/summary_daemon/do_wearing_payment_test_data_insert/';
    const response = await postTestData(url)
    console.log(response.data)
  }

  useEffect(() => {
    getSummaryData()
  }, [])

  const onSearch = () => {
    setSearchState(prev => prev + 1)
  }

  useEffect(() => {
    onSearch()
  }, [settlementDate])
  
  useEffect(() => {
    setSearchState(0)
  }, [settlementState])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>처리장 정산관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="정산관리" breadcrumbItem="처리장 정산관리" />

          <Row>
            <Col xs='12'>
              <div className="email-rightbar mb-3">
                <Card>
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">상호검색</td>
                          <td className="col-20">
                            <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={searchCondition.companyName} onChange={(e) => {
                              changeSearchCondition('companyName', e.target.value)
                            }} />
                          </td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">사업자번호 검색</td>
                          <td className="col-20">
                            <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="사업자번호를 입력하세요." value={searchCondition.companyNumber} onChange={(e) => {
                              changeSearchCondition('companyNumber', e.target.value)
                            }} />
                          </td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12"></td>
                          <td className="col-20">
                          </td>
                          <td className="col-10 padding-left-8 no-border" rowSpan={3}>
                            <div className="d-flex flex-direction-column align-items-end">
                              <button type="button" className="custom-btn btn-dark-gradient w-80 margin-bottom-8 border-radius-0 white-text border-none margin-right-0" onClick={() => {
                                onSearch()
                              }}>
                                검색
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <Row>
            {dashboardItem.map((item, index) => (
              <Col xs={3} key={'collection_history_dashboard_' + index}>
                <div className="collect-history-box d-flex justify-content-between">
                  <div className="d-flex flex-column justify-content-between">
                    <p className="font-size-15 mb-0">{item.text}</p>
                  </div>
                  <div className="d-flex flex-column justify-content-end">
                    <p className="mb-0 font-size-50 font-weight-800 line-height-1">
                      {Util.setCommaPrice(item.value)}
                      <span className="font-size-18 font-weight-600"> {item.unit}</span>
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <div className="d-flex align-items-center mb-2 margin-top-40 justify-content-between">
            <div className="d-flex align-items-center">
              <button style={{ width: 100, height: 35 }} type="button" className={`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 ${settlementState === 'settlement' ? selectedClass : unselectedClass}`} onClick={() => {
                setSettlementState('settlement')
              }}>
                정산내역
              </button>
              <button style={{ width: 100, height: 35 }} type="button" className={`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 ${settlementState === 'payment' ? selectedClass : unselectedClass}`} onClick={() => {
                setSettlementState('payment')
              }}>
                고지내역
              </button>
              <div className="margin-right-4" style={{ width: 135 }}>
                <SelectBox
                  value={paymentStatus}
                  onChange={(key, value) => setPaymentStatus(value || 'A')}
                  options={paymentStatusList}
                  keyValue={'paymentStatus'}
                />
              </div>
              <input className="waver-input-box border-radius-0 margin-right-16" style={{ width: 135 }} type="month" value={settlementDate} onChange={(e) => {
                setSettlementDate(e.target.value)
              }} />
              <p className="mb-0 font-size-16"><span className="font-weight-bold">정산 목록</span> [ 건수 : {listCount}건 ]</p>
            </div>
            <div className="waver-pagination-btn-group" >
              <button style={{ width: 143 }} className="custom-btn success-bg border-radius-0 white-text border-none margin-right-0"
                onClick={() => {
                  excelDownload()
                  // testData()
                }} >
                엑셀 다운로드
              </button>
            </div>
          </div>
          <Row>
            <Col xs="12">
            {console.log(settlementState, type)}
              {settlementState === 'settlement' && type === 'collection' && <CollectionSettlement companyName={searchCondition.companyName} companyNumber={searchCondition.companyNumber} settlementDate={settlementDate} getListLength={setListCount} searchState={searchState} paymentStatus={paymentStatus} />}
              {settlementState === 'payment' && type === 'collection' && <CollectionPayment companyName={searchCondition.companyName} companyNumber={searchCondition.companyNumber} settlementDate={settlementDate} getListLength={setListCount} searchState={searchState} paymentStatus={paymentStatus} />}
              {settlementState === 'settlement' && type === 'treatment' && <TreatmentSettlement companyName={searchCondition.companyName} companyNumber={searchCondition.companyNumber} settlementDate={settlementDate} getListLength={setListCount} searchState={searchState} paymentStatus={paymentStatus} />}
              {settlementState === 'payment' && type === 'treatment' && <TreatmentPayment companyName={searchCondition.companyName} companyNumber={searchCondition.companyNumber} settlementDate={settlementDate} getListLength={setListCount} searchState={searchState} paymentStatus={paymentStatus} />}
            </Col>
          </Row>
        </Container>
      </div>

      <Modal title={''} show={modalShow.detail} onHide={() => { modalClose('detail') }} size="md"><div className="d-flex justify-content-center w-100">
        <div className="bill-mock-up">
          <div className="header">
            <p className="header-text">{`2025년 6월 ${settlementState === 'settlement' ? '정산' : '고지'} 내역 상세`}</p>
          </div>
          <div className="main-banner">
            <div className="text-container">
              <p className="banner-main-text">스마트<br /><span>수거 플랫폼</span></p>
              <p className="banner-sub-text">Smart Food Waste Collection Platform</p>
            </div>
            <img className="logo" src={weaverOverlay} />
          </div>
          <p className="company">처리장명1</p>
          {settlementState === 'settlement' ?
            <Fragment>
              <div className="charge-box margin-top-14">
                <div className="d-flex align-items-end">
                  <p className="charge">인계 현황</p>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="month-charge-text">인계량 / kg</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="charge-box margin-top-12">
                <div className="d-flex align-items-end">
                  <p className="charge">정산 금액</p>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="all-charge-text">고지금액</p>
                    <div className="white-value-box">
                      <p className="box-text all-charge-box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                  <p className="explanation">정산금액은 인계된 폐기물의 양을 기준으로 합니다.</p>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="month-charge-text">금월 청구금액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">VAT</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">납부금액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">미납금액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">완납여부</p>
                    <div className="white-value-box">
                      <p className="box-text">{selectedItem?.state === 'Y' ? '완납' : '미납'}</p>
                    </div>
                  </div>
                </div>
                <div className="line line-1"></div>
                <div className="line line-2"></div>
              </div>
            </Fragment>
            :
            <Fragment>
              <div className="charge-box margin-top-14">
                <div className="d-flex align-items-end">
                  <p className="charge">고지 내역</p>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="all-charge-text">총 금액</p>
                    <div className="white-value-box">
                      <p className="box-text all-charge-box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                  <p className="explanation">정산금액은 인계된 폐기물의 양을 기준으로 합니다.</p>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="month-charge-text">납부금액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">미납금액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">완납여부</p>
                    <div className="white-value-box">
                      <p className="box-text">{selectedItem?.state === 'Y' ? '완납' : '미납'}</p>
                    </div>
                  </div>
                </div>
                <div className="line line-1"></div>
                <div className="line line-2"></div>
              </div>
              <div className="charge-box margin-top-12">
                <div className="d-flex align-items-end">
                  <p className="charge">미납금액</p>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="month-charge-text">당월 미정산액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">이전 미정산액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(0)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          }
          {settlementState === 'payment' &&
          <div className="payment-button" style={{marginBottom: -48}}>
            <p>세금계산서 청구서 작성</p>
          </div>
          }
        </div>
      </div>
        {isLoading && <Loading />}
      </Modal>

      {isLoading && <Loading />}
    </React.Fragment>
  )
}

export default TreatmentSettlementManagement
